module.exports = __webpack_public_path__ + "static/widgets_5-b7cb8f52a84fc440581f4a6e774e535b.png";